const root = state => state.dataPrivacySettings;
export const getDataPrivacySettingsRequestState = state => root(state).requestState;
export const getIsLegalConsentEnabled = state => root(state).gdprToggleEnabled;